import React from "react";
import messages_es from "./translations/es.json";
import messages_en from "./translations/en.json";
// import messages_pt from "./translations/pt.json";

import "moment/locale/pt";
import "moment/locale/es";
import {FormattedMessage} from "react-intl";

export default React.createContext({
    _initialized: false,

    tenant: null,

    resort: null,

    // Dejarlo en blanco asi podemos saber si alguna vez se inicio
    // De esa manera podemos saber si mostrar el idioma que viene en el link, o el que tiene grabado en el store
    language: '',

    languageList: {
        es: {
            name: "Español",
            messages: messages_es
        },
        en: {
            name: "English",
            messages: messages_en
        },
        // pt: {
        //     name: "Portugues",
        //     messages: messages_pt
        // }
    },

    _resortData: null,

    initializeStore: function() {
        if (!this._initialized) {
            this._initialized = true;

            const storedLanguage = localStorage.getItem('language');
            this.language = this.languageList[storedLanguage] ? storedLanguage : 'es';
       }
    },

    setResortData: function(resortData) {
        this.tenant = resortData['tenant'];
        this.resort = resortData['resort'];
        this._resortData = resortData;
    },

    getResortData: function() {
        return this._resortData;
    },

    _getLocalStorage: function(itemName) {
        return localStorage.getItem(this.tenant + '_' + this.resort + '_' + itemName);
    },

    _setLocalStorage: function(itemName, itemValue) {
        localStorage.setItem(this.tenant + '_' + this.resort + '_' + itemName, itemValue);
    },

    saveSession: function() {
        localStorage.setItem('language', this.language);
    },

    isLogged: function() {
        return Boolean(this._getLocalStorage('isLogged') === '1');
    },

    authenticate: function(credentials) {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(credentials)
        };
        const that = this;

        return fetch(this.getApiUriPrefix() + `/bookings/find`, requestOptions)
            .then(function(response) {
                if (response.ok)
                    return response.json();
                else
                    throw Error(response.statusText);
            })
            .then(function(json) {
                if (Object.keys(json).length === 1) {
                    const booking = json[0];

                    if ( booking['status'] < 40 ) {
                        that._setLocalStorage('isLogged', 1);
                        that._setLocalStorage('userName', booking['guests'][0]['name'] + ' ' + booking['guests'][0]['surname']);
                        that._setLocalStorage('credentials', JSON.stringify(credentials));

                        return {
                            ok: true,
                            error: ''
                        }
                    }
                }

                return {
                    ok: false,
                    error: 'Reserva no encontrada. Revise los datos ingresados'
                }
            });
    },

    signOut: function(cb) {
        this._setLocalStorage('isLogged', 0);
        setTimeout(cb, 300);
    },

    setLanguage: () => {},

    getApiUriPrefix: function() {
        return this._resortData['baseApiUrl'];
    },

    getUserName: function() {
        return this._getLocalStorage('userName');
    },


    formatMessage: function(messageId) {
        const messages = this.languageList[this.language].messages;
        return messages[messageId];
    },

    getCredentials: function() {
        return JSON.parse(this._getLocalStorage('credentials'));
    },

    getBookingData: function(cb) {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(this.getCredentials())
        };

        fetch(this.getApiUriPrefix() + `/bookings/find`, requestOptions)
            .then(function(response) {
                if (response.ok)
                    return response.json();
                else
                    throw Error(response.statusText);
            })
            .then(function(json) {
                if (Object.keys(json).length === 1) {
                    cb.call(this, json[0]);
                }
                else {
                    throw Error(this.formatMessage('app.login.reservation-not-found'))
                }
            })
            .catch(function() {
            });
    }
});


